<style lang="less" scoped>
.linjwResourcesList {
    .el-container {
        background-color: white;
    }
    .el-container .el-container .el-header {
        height: 52px !important;
    }
    .el-container .el-container .el-main {
        padding: 0px !important;
    }
    position: relative;
    .treesbox{
        position: absolute;
        left: 0px
    }
    .right {
        width: 100%;
        padding-left: 10px;
        box-sizing: border-box;
        overflow: hidden;
        .text{
            font-size: 16px;
        }
        .el-divider--horizontal {
            display: block;
            height: 1px;
            width: 100%;
            margin: 13px 0;
        }
        .count-table {
            margin-top: 20px;
            margin-bottom: 20px;
        }
        .count-table h2 {
            margin: 0px 0 10px 30px;
            font-size: 20px;
            font-weight: bold;
        }
    }
    .right .rightTop {
        display: inline-block; width: 100%;
        .rightTopLeft {
            float: left;
            .rightTopLeftI {
                font-size: 20px; color: #c0c4cc; padding-right: 10px;
            }
            .rightTopLeftII {
                font-size: 20px; color: #409EFF; padding-right: 10px;
            }
        }
    }

    .rightTopRight {
        padding-right: 10px;
    }
}
</style>
<template>
    <div class="linjwResourcesList">
        <el-container style="height: 100%;">
            <el-aside width="230px" style="border-right: #dcdfe6 solid 1px">
                <Evtree :treeData="treeData" :width="220" class="treesbox" node-key="id" :expandedKeys="['0']" :default-expanded-keys="[0]" :default-expand-all="true" :rightClick="false"
                        :accordion="true" :treeAction="treeAction" :auth="auth" @treeNodeclick="treeNodeclick" placeholder="输入旅游资源名称进行过滤" :expand-on-click-node="eocNode"></Evtree>
            </el-aside>
            <el-container class="right">
                <el-header class="rightTop" style="font-size: 12px; background-color: white; display: table; height: 40px !important;">
                    <div class="rightTopLeft">
                        <el-radio-group v-model="chartType" size="mini" @change="chartTypeChange">
                            <el-radio-button label="0"><i class="fa fa-home"></i></el-radio-button>
                            <el-radio-button label="1"><i class="fas fa-chart-pie"></i></el-radio-button>
                            <el-radio-button label="2"><i class="fas fa-chart-bar"></i></el-radio-button>
                        </el-radio-group>
                        <el-backtop ref="zdyBack" target=".rightContent" v-show="false"></el-backtop>
                    </div>
                    <div class="rightTopRight" style="float: right">
                        <EvareaChoose v-show="request.getSession('userInfo').dsType != 3"
                                      style="float: left; margin-right: 5px; margin-bottom: 3px; width: 225px" placeholder="请选择所属区划"
                                      v-model="areaCode" :level="areaLevel" :resetcode="initCode" @onchange="areaCodeChange"
                                      :checkStrictly="true" :showAllLevels="true"
                        ></EvareaChoose>
                        <el-date-picker size="mini" style="float: left; margin-right: 5px; width: 225px;" v-model="dateRange" type="daterange" @change="dateChange"
                                        value-format="yyyy-MM-dd" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                        <el-button style="height: 28px" size="mini" type="primary" @click="getDeptInfo">查询</el-button>
                        <el-button style="height: 28px" size="mini" type="warning" @click="reset">重置</el-button>
                    </div>
                </el-header>

                <el-main class="rightContent">
                    <div style="margin-right: 10px;">
                        <el-card class="box-card" style="margin-bottom: 10px" v-show="chartType == '0' || chartType == '1'">
                            <div ref="simplePie" id="cl-pie" style="width: 100%; height: 360px;"></div>
                        </el-card>
                        <el-card class="box-card" style="margin-bottom: 10px"  v-show="chartType == '0' || chartType == '2'">
                            <div ref="simpleBar" id="cl-bar" style="width: 100%; height: 360px;"></div>
                        </el-card>
                        <el-card class="box-card" style="margin-bottom: 10px"   v-show="chartType == '1'">
                            <div class="count-table">
                                <h2 style="color: black; font-size: 18px; width: 45%;float: left;margin-bottom: 5px;">详细数据</h2>
                                <div class="tbutton" style="width: 50%;display: inline-block;">
                                    <el-button style="float: right; margin-right: 5px;" type="success" size="mini" @click="exportTable">导出Excel</el-button>
                                </div>
                                <el-table
                                        id="etable"
                                        :data="tableData"
                                        border
                                        size="mini "
                                        :header-cell-style="tableHeaderColor"
                                        style="width: 95% ; borderRadius:5px; margin: auto">
                                    <el-table-column
                                            prop="name"
                                            label="资源名称">
                                    </el-table-column>
                                    <el-table-column
                                            prop="num"
                                            label="资源数量">
                                    </el-table-column>
                                    <el-table-column
                                            prop="ratio"
                                            label="资源占比">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-card>
                        <el-card class="box-card" style="margin-bottom: 10px;" v-show="chartType == '2'">
                            <div class="count-table">
                                <h2 style="color: black; font-size: 18px; width: 45%;float: left;margin-bottom: 5px;">详细数据</h2>
                                <div class="tbutton" style="width: 50%;display: inline-block;">
                                    <el-button style="float: right; margin-right: 5px;" type="success" size="mini" @click="exportBarTable()">导出Excel</el-button>
                                </div>
                                <el-table
                                        id="btable"
                                        :data="barTableData"
                                        border
                                        size="mini "
                                        :header-cell-style="tableHeaderColor"
                                        style="width: 95% ; borderRadius:5px; margin: auto">
                                    <el-table-column
                                            v-for="item in barTableHead"
                                            :prop="item.prop"
                                            :label="item.label">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-card>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import FileSaver from 'file-saver'
    import XLSX from 'xlsx'
    export const on = (function () {
        if (document.addEventListener) {
            return function (element, event, handler) {
                if (element && event && handler) {
                    element.addEventListener(event, handler, false)
                }
            }
        } else {
            return function (element, event, handler) {
                if (element && event && handler) {
                    element.attachEvent('on' + event, handler)
                }
            }
        }
    })()
    export default {
        components: {echarts},
        data() {
            var _this = this;
            return {
                chartType: 0,
                eocNode: true,
                dateRange: '',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }],
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                areaCode: "",
                queryAreaCode: "",
                initCode: "0",
                areaLevel: 0,
                maxLevel: "5",
                treeData: [{
                    label: "旅游资源",
                    expand: false,
                    id: "0",
                    level: 0,
                    name: "旅游资源",
                    title: "旅游资源",
                    children: []
                }],
                auth: {},
                th: this,

                //数据结构定义开始
                queryParams: {
                    resourceCode: "",
                    rChildLength: null,
                    startDate: "",
                    endDate: "",
                    pieRegion: ""
                },
                resourceList: [
                    {
                        value:0, name:'景区', table: "scenic"
                    }, {
                        value:0, name:'自驾营地', table: "drive_camp"
                    }, {
                        value:0, name:'农家乐', table: "entertainment"
                    }, {
                        value:0, name:'旅行社', table: "travel_agent"
                    }, {
                        value:0, name:'租车', table: "rental_car"
                    }, {
                        value:0, name:'交通枢纽', table: "traffic_agent"
                    },{
                        value:0, name:'周边', table: "periphery"
                    }
                ],
                resourceLegendData: ['景区','自驾营地','农家乐','旅行社','租车','交通枢纽','周边'],
                legendData: ['景区','自驾营地','农家乐','旅行社','租车','交通枢纽','周边'],
                barSeries: [
                    {
                        name: '景区',
                        table: "scenic",
                        type: 'bar',
                        stack: '总量',
                        barMaxWidth: 50,
                        label: {
                            show: true,
                        },
                        data: []
                    },
                    {
                        name: '自驾营地',
                        table: "drive_camp",
                        type: 'bar',
                        stack: '总量',
                        barMaxWidth: 50,
                        label: {
                            show: true,
                        },
                        data: []
                    },
                    {
                        name: '农家乐',
                        table: "entertainment",
                        type: 'bar',
                        stack: '总量',
                        barMaxWidth: 50,
                        label: {
                            show: true,
                        },
                        data: []
                    },
                    {
                        name: '旅行社',
                        table: "travel_agent",
                        type: 'bar',
                        stack: '总量',
                        barMaxWidth: 50,
                        label: {
                            show: true,
                        },
                        data: []
                    },
                    {
                        name: '租车',
                        table: "rental_car",
                        type: 'bar',
                        stack: '总量',
                        barMaxWidth: 50,
                        label: {
                            show: true,
                        },
                        data: []
                    },
                    {
                        name: '交通枢纽',
                        table: "traffic_agent",
                        type: 'bar',
                        stack: '总量',
                        barMaxWidth: 50,
                        label: {
                            show: true,
                        },
                        data: []
                    },
                    {
                        name: '周边',
                        table: "periphery",
                        type: 'bar',
                        stack: '总量',
                        barMaxWidth: 50,
                        label: {
                            show: true,
                        },
                        data: []
                    }
                ],
                barXAxisData: [],
                barXAxisDataRel: [],
                //数据结构定义结束
                pageload: false,
                treeAction:[],
                tableData: [],
                barTableHead: [],
                barTableData: [],
                // 修改table header的背景色
                tableHeaderColor({row, column, rowIndex, columnIndex}) {
                    if (rowIndex === 0) {
                        return 'background-color: #ccc;color: #000;font-weight: 1000;'
                    }
                },
            };
        },
        methods: {
            chartTypeChange(val){
                this.$refs.zdyBack.handleClick();
            },
            //页面初始化参数方法
            init(){
                let dsType = this.request.getSession('userInfo').dsType;
                let areaCode = this.request.getSession('userInfo').org.areaCode;
                if(dsType == 1){
                    this.initCode = "0";
                    this.areaLevel = 3;
                    this.queryAreaCode = "0";
                }else {
                    if(areaCode.length < 6){
                        this.initCode = areaCode;
                        this.areaLevel = 2;
                    }else{
                        this.initCode = "-1";
                        this.areaLevel = 0;
                    }
                    this.queryParams.pieRegion = areaCode;
                    let code = "";
                    for(let i=0; i<areaCode.length;){
                        code += areaCode.substring(0, i+2)+",";
                        i = i+2;
                    }
                    this.queryAreaCode = code.substring(0, code.length-1);
                }
                this.getDeptInfo();
            },
            /**
             * 所属区划选择后触发的函数
             */
            areaCodeChange(a,b){

                /** 所属区划赋值代码，不能删，删除后重置不起作用，原因：所属区划是单向绑定，非双向绑定 **/
                this.areaCode = a[a.length-1];
                this.queryParams.pieRegion = a[a.length-1];
                /** 所属区划赋值代码，不能删，删除后重置不起作用，原因：所属区划是单向绑定，非双向绑定 **/

                let dsType = this.request.getSession('userInfo').dsType;
                let areaCode = this.request.getSession('userInfo').org.areaCode;
                let code = "";
                if(dsType == 1){
                    for(let i=0; i<a.length; i++){
                        code += a[i]+",";
                    }
                    this.queryAreaCode = code.substring(0, code.length-1);
                }else {
                    for(let i=0; i<areaCode.length;){
                        code += areaCode.substring(0, i+2)+",";
                        i = i+2;
                    }
                    code = code.substring(0, code.length-1);
                    this.queryAreaCode = code;
                    for(let i=0; i<a.length; i++){
                        this.queryAreaCode += ","+a[i];
                    }
                }
            },
            dateChange(val){
                debugger
                this.queryParams.startDate = val[0]+ " 00:00:00"
                this.queryParams.endDate = val[1]+ " 23:59:59"
            },
            query(){
                this.queryParams.barXAxisDataRel = this.barXAxisDataRel;
                if(this.queryParams.resourceCode == null || this.queryParams.resourceCode == ""){
                    this.queryParams.resource_list = this.resourceList;
                    this.queryParams.barSeries = this.barSeries;
                    this.getPieData();
                    this.getBarData();
                }else{
                    this.initPieData();
                    this.initBarData();
                }
            },
            reset(){
                /** 重置右侧左上角的展示切换 **/
                this.chartType = "0";
                /** 重置右侧左上角的展示切换 **/
                this.areaCode = "";
                this.dateRange = "";
                this.queryParams.pieRegion = "";
                this.queryParams.startDate = "";
                this.queryParams.endDate = "";
                this.init();
            },
            treeNodeclick(node, data) {
                if(data.children == null || data.children.length == 0){
                    this.charts = echarts.init(this.$refs.simplePie);
                    this.charts.setOption({
                        title:{
                            textStyle:{
                                color:'#bcbcbc'
                            },
                            text:'暂无数据',
                            left:'center',
                            top:'center'
                        }
                    }, true);
                    this.charts = echarts.init(this.$refs.simpleBar)
                    this.charts.setOption({
                        title:{
                            textStyle:{
                                color:'#bcbcbc'
                            },
                            text:'暂无数据',
                            left:'center',
                            top:'center'
                        }
                    }, true);
                    this.tableData = [];
                    this.barTableData = [];
                    return;
                }
                this.queryParams.rChildLength = data.children.length;
                if(data.id == 0 || data.id == "0"){
                    this.eocNode = false;
                    this.queryParams.resourceCode = "";
                    this.legendData = this.resourceLegendData;
                    this.reset();
                }else{
                    this.eocNode = true;
                    this.queryParams.resourceCode = data.code;
                    this.getDeptInfo();
                }
            },
            initPieData(){
                let that = this;
                that.request.post('/wtcp-bics/resource/initPieByCode', that.queryParams).then(res => {
                    if(res.status == 1){
                        let arr = [];
                        for(let i=0; i<res.data.length; i++){
                            arr.push(res.data[i].name);
                        }
                        that.legendData = arr;
                        that.drawPie(res.data);
                        that.initTableData(res.data);
                    }
                })
            },
            initBarData(){
                let that = this;
                that.request.post('/wtcp-bics/resource/initBarByCode', that.queryParams).then(res => {
                    if(res.status == 1){
                        for(let i=0; i<res.data.length; i++){
                            if(res.data[i].data == null || res.data[i].data.length == 0){
                                res.data[i].data.push(0);
                                res.data[i].label.formatter = that.formatShow;
                                res.data[i].label.position = "top";
                                res.data[i].label.distance = "150";
                                res.data[i].label.fontSize = 20;
                                res.data[i].label.color = '#c2c2c2';
                            }
                        }
                        that.drawBar(res.data);
                        that.initBarTable(that.barXAxisData, res.data);
                    }
                })
            },

            formatShow(num){
                if(num.value == 0){
                    return "暂无数据"
                }
            },

            /**
             * 以下是画图的
             */
            drawPie(data) {
                this.charts = echarts.init(this.$refs.simplePie);
                this.charts.setOption({
                    title : {
                        text: '资源类型占比',
                        x:'left'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'right',
                        data: this.legendData
                    },
                    series : [
                        {
                            name: '资源类型占比',
                            type: 'pie',
                            radius : '70%',
                            center: ['40%', '50%'],
                            data: data,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                normal: {
                                    label:{
                                        show: true,
                                        formatter: '{b} : {c} ({d}%)'
                                    }
                                }
                            }
                        }
                    ]
                }, true);
            },
            drawBar(data) {
                this.charts = echarts.init(this.$refs.simpleBar)
                this.charts.setOption({
                    title: {
                        text: '机构类型统计'
                    },
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        data: this.legendData,
                        left:'right',
                    },
                    grid: {
                        left: '1%',
                        right: '1%',
                        bottom: '1%',
                        containLabel: true
                    },
                    xAxis:  {
                        type: 'category',
                        data: this.barXAxisData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: data
                }, true);
            },
            showLoading() {
                this.charts.showLoading({
                    text: "正在努力加载...",
                    x: "center",
                    y: "center",
                    textStyle: {
                        color: '#c23531',
                        fontSize: 14
                    },
                    effect: "spin"
                });
            },
            hideLoading() {
                this.charts.hideLoading();
            },
            resize(){
                this.charts.resize();
            },
            //初始化左侧树
            getBicsTree(){
                let that = this;
                this.request.get('/wtcp-coder/rpc/dict/findByCode', {code: '125'}).then(res => {
                    if(res.status == 1){
                        const child = that.getsorl(res.data, that.maxLevel);
                        that.treeData[0].children = child;
                    }
                })
            },
            /** 第一次初始化时调用的接口开始 **/
            //初始化饼状图数据
            getPieData(){
                let that = this;
                that.request.post('/wtcp-bics/resource/findByPieChart', that.queryParams).then(res => {
                    if(res.status == 1){
                        that.drawPie(res.data);
                        that.initTableData(res.data);
                    }
                })
            },
            //初始化饼状图数据
            getBarData(){
                let that = this;
                that.request.post('/wtcp-bics/resource/findByBarChart', that.queryParams).then(res => {
                    if(res.status == 1){
                        for(let i=0; i<res.data.length; i++){
                            if(res.data[i].data == null || res.data[i].data.length == 0){
                                res.data[i].data.push(0);
                                res.data[i].label.formatter = that.formatShow;
                                res.data[i].label.position = "top";
                                res.data[i].label.distance = "150";
                                res.data[i].label.fontSize = 20;
                                res.data[i].label.color = '#c2c2c2';
                            }
                        }
                        that.drawBar(res.data);
                        that.initBarTable(that.barXAxisData, res.data);
                    }
                })
            },

            initTableData(data){
                let arr = [];
                let sum = 0;
                for(let s=0; s< data.length; s++){
                    sum = Number(sum) + Number(data[s].value);
                }
                let s = {
                    name: "全部",
                    num: Number(sum),
                    ratio: Number(sum) == 0? "0%": "100%"
                }
                arr.push(s);
                for(let i=0; i<data.length; i++){
                    let r = Number(sum) == 0? "0%":Math.round(Number(data[i].value) / Number(sum) * 10000) / 100.00 + "%";
                    let o = {
                        name: data[i].name,
                        num: data[i].value,
                        ratio: r
                    }
                    arr.push(o);
                }
                this.tableData = arr;
            },
            initBarTable(area, res){
                let arr = [];
                let data = [];
                let o = {
                    prop: "area",
                    label: "机构"
                };
                arr.push(o);
                for(let j=0; j<res.length; j++){
                    let s = {
                        prop: res[j].name,
                        label: res[j].name
                    };
                    arr.push(s);
                }
                for(let i=0; i<area.length; i++){
                    let d = {
                        area: area[i]
                    };
                    for(let l=0; l<res.length; l++){
                        d[res[l].name] = res[l].data[i];
                    }
                    data.push(d);
                }
                this.barTableHead = arr;
                this.barTableData = data;
            },

            //导出table为excel表
            exportTable() {
                /* generate workbook object from table */
                var wb = XLSX.utils.table_to_book(document.querySelector('#etable'), {raw: true})
                /* get binary string as output */
                var wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'})
                try {
                    FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), '旅游资源分析统计表.xlsx')
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout)
                }
                return wbout
            },

            //导出table为excel表
            exportBarTable() {
                /* generate workbook object from table */
                var wb = XLSX.utils.table_to_book(document.querySelector('#btable'), {raw: true})
                /* get binary string as output */
                var wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'})
                try {
                    FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), '机构类型分析统计表.xlsx')
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, wbout)
                }
                return wbout
            },

            /** 第一次初始化时调用的接口结束 **/
            //树形结构添加排序值
            getsorl(data, foolr) {
                for (var i in data) {
                    if (data[i].level === foolr) {
                        data[i].title = data[i].name;
                        data[i].label = data[i].name;
                    } else {
                        this.getsorl(data[i].children, foolr);
                        data[i].title = data[i].name;
                        data[i].label = data[i].name;
                    }
                }
                return data;
            },
            getDeptInfo(){
                let that = this;
                that.barXAxisData = [];
                that.barXAxisDataRel = [];
                that.request.get('/wtcp-bics/resource/findChildByAreaCode', {areaCode: this.queryAreaCode}).then(res => {
                    if(res.status == 1 && res.data.length > 0){
                        let data = res.data;
                        for(let i = 0; i < data.length; i++){
                            if(data[i].areaCode != null && data[i].areaCode.length > 0){
                                let o = {
                                    name: data[i].name,
                                    areaCode: data[i].areaCode.split(",")[data[i].areaCode.split(",").length - 1]
                                }
                                that.barXAxisData.push(data[i].name);
                                that.barXAxisDataRel.push(o);
                            }
                        }
                    }
                    that.query();
                })

            }
        },
        created() {
            this.request.getAuth(this);
            this.init();
            this.getBicsTree();
        },
        // mounted() {
        //     this.$nextTick(function () {
        //         this.drawBar();
        //     });
        // }
    };
</script>